/** Phase 20 */
import { getAggregateMetadata } from '../infrastructure/storage/domainAggregateStore';
import { getEntityMetadata } from '../infrastructure/storage/entityAggregateStore';
import { createRootDocumentEntityReadSource } from './rootDocumentEntityReadSourceFactory';

const source = createRootDocumentEntityReadSource({
  field: 'metadata',
  getEntity: getEntityMetadata,
  getAggregate: getAggregateMetadata,
  emptyValue: {}
});

export const readMetadataFromMergedBlob = source.readFromMergedBlob;
export const readMetadataFromBestSource = source.readFromBestSource;
export const refreshMetadataReadCache = source.refreshReadCache;
export const getCachedMetadataRead = source.getCachedRead;
export const clearMetadataReadCache = source.clearReadCache;
export const readMetadataSyncForBusiness = source.readSyncForBusiness;
